import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauAnnulerAction from '../actions/BordereauAnnulerAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauRejeterCollectiviteAction from '../actions/BordereauRejeterCollectiviteAction';
import BordereauRelancerFlux360Action from '../actions/BordereauRelancerFlux360Action';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauEnEchecState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.EN_ECHEC;
		this.state = BordereauStateType.EN_ECHEC;
		this.color = '#CF0000';
		this.libelle = 'En échec';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauRelancerFluxAction({ isActionPrincipale: true }),
			new BordereauRelancerFlux360Action(),
			new BordereauDupliquerAction(),
			new BordereauAnnulerAction(),
			new BordereauRejeterCollectiviteAction(),
			...(userRole === UserRole.ADMIN
				? [
						new BordereauModifierAction({ isSuperUser: true }),
						new BordereauDenumeroterAction({ isSuperUser: true }),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...this.getActionsAnnulationRejet(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauEnEchecState;
